var map = {
	"./MESTNA OBCINA KOPER.png": "cb1a",
	"./MESTNA OBCINA KRANJ.png": "a6b6",
	"./MESTNA OBCINA MARIBOR.png": "0c25",
	"./MESTNA OBCINA MURSKA SOBOTA.png": "07f8",
	"./MESTNA OBCINA NOVA GORICA.png": "a268",
	"./MESTNA OBCINA PTUJ.png": "c9e4",
	"./MESTNA OBCINA SLOVENJ GRADEC.png": "7122",
	"./OBCINA AJDOVSCINA.png": "016c",
	"./OBCINA BENEDIKT.png": "4a97",
	"./OBCINA BOHINJ.png": "0b70",
	"./OBCINA BOVEC.png": "edca",
	"./OBCINA BRASLOVCE.png": "7eef",
	"./OBCINA BREZICE.png": "6d09",
	"./OBCINA CERKNO.png": "08b3",
	"./OBCINA CIRKULANE.png": "8bda",
	"./OBCINA CRNA NA KOROSKEM.png": "bb24",
	"./OBCINA DOBREPOLJE.png": "e99c",
	"./OBCINA DOL PRI LJUBLJANI.png": "42b5",
	"./OBCINA DOMZALE.png": "efea",
	"./OBCINA DRAVOGRAD.png": "2f23",
	"./OBCINA GORNJA RADGONA.png": "80ea",
	"./OBCINA HAJDINA.png": "31f2",
	"./OBCINA HRASTNIK.png": "8f4f",
	"./OBCINA HRPELJE-KOZINA.png": "aad6",
	"./OBCINA ILIRSKA BISTRICA.png": "98fb",
	"./OBCINA IZOLA.png": "333c",
	"./OBCINA JESENICE.png": "5228",
	"./OBCINA KANAL.png": "154d",
	"./OBCINA KOMEN.png": "b817",
	"./OBCINA KRSKO.png": "d795",
	"./OBCINA LOGATEC.png": "7172",
	"./OBCINA LOSKA DOLINA.png": "355a",
	"./OBCINA MARKOVCI.png": "2fb2",
	"./OBCINA MEDVODE.png": "ab58",
	"./OBCINA METLIKA.png": "e98f",
	"./OBCINA MISLINJA.png": "86de",
	"./OBCINA MORAVCE.png": "343d",
	"./OBCINA PESNICA.png": "9966",
	"./OBCINA PIRAN.png": "d6d2",
	"./OBCINA PODVELKA.png": "5049",
	"./OBCINA POSTOJNA.png": "01eb",
	"./OBCINA PREBOLD.png": "6d17",
	"./OBCINA PREDDVOR.png": "fff7",
	"./OBCINA RACE-FRAM.png": "fb63",
	"./OBCINA RADECE.png": "b69d",
	"./OBCINA RADLJE OB DRAVI.png": "bd01",
	"./OBCINA RADOVLJICA.png": "f4e1",
	"./OBCINA RENCE-VOGRSKO.png": "109b",
	"./OBCINA RIBNICA NA POHORJU.png": "8be4",
	"./OBCINA SEMIC.png": "9b67",
	"./OBCINA SENTILJ.png": "9225",
	"./OBCINA SEVNICA.png": "5b80",
	"./OBCINA SEZANA.png": "5890",
	"./OBCINA SKOFJA LOKA.png": "d355",
	"./OBCINA SKOFLJICA.png": "f1b0",
	"./OBCINA SLOVENSKE KONJICE.png": "e3f2",
	"./OBCINA SVETA TROJICA V SLOVENSKIH GORICAH.png": "b794",
	"./OBCINA TRZIN.png": "3176c",
	"./OBCINA VITANJE.png": "320b",
	"./OBCINA VRHNIKA.png": "49ec",
	"./OBCINA ZALEC.png": "a37e",
	"./OBCINA ZIROVNICA.png": "49c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9836";